import { memo } from 'react'

/** React.memo wrapper tu use memo with generic */
export const typedMemo: <T>(c: T) => T & { displayName: string } = memo
